module.exports = __webpack_public_path__ + "img/q60-22.180de58a.jpg";